module.exports = __webpack_public_path__ + "img/raccoon.39442d63.svg";